import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import submissionSuccessIcon from "../../assets/submission_success_icon.svg";
import homeIcon from "../../assets/timetrails/home_icon.svg";
import iconRight from "../../assets/timetrails/icon_right.svg";
import "./TimeTrailsTask.css";

export const SubmissionSuccessScreen = ({
  onPreview,
  taskName,
  isResubmit = false,
}) => {
  return (
    <div className="submission-success-screen">
      {/* Breadcrumbs */}
      <div className="timetrails-task__breadcrumbs">
        <Link to="/quest" className="breadcrumb-link">
          <div className="breadcrumb-home-icon-container">
            <img src={homeIcon} alt="Home" className="breadcrumb-home-icon" />
          </div>
          <span className="breadcrumb-link-text">Home</span>
        </Link>
        <img
          src={iconRight}
          alt="icon_right"
          className="breadcrumb-home-icon-right"
        />

        <span className="breadcrumb-current">Time Trial Task</span>
      </div>

      {/* Success Content */}
      <div className="submission-success-screen__content">
        <h1 className="submission-success-screen__title">
          {isResubmit ? "Resubmission Sent!" : "Submission Sent!"}
        </h1>
        <p className="submission-success-screen__subtitle">
          An admin will review your submission shortly.
        </p>

        {/* Success Icon */}
        <div className="submission-success-screen__icon">
          <div className="success-circle">
            <img
              src={submissionSuccessIcon}
              alt="Success"
              className="checkmark-icon"
              width="1000"
              height="230"
            />
          </div>
        </div>

        {/* Preview Button */}
        <Button variant="outlined" onClick={onPreview} className="preview-btn">
          Preview
        </Button>
      </div>
    </div>
  );
};
